import classNames from 'classnames'

import {useBuildsClassName} from '../../../../common/Builds/Builds'
import type {GridProps} from '../../../../common/Grid/Grid'
import Grid from '../../../../common/Grid/Grid'

import styles from './ChangeBuilds.css'

function ChangeBuildsGrid({className, ...restProps}: GridProps) {
  return <Grid className={classNames(styles.grid, useBuildsClassName())} {...restProps} />
}

export default ChangeBuildsGrid
